// src/rooms/roomsApi.ts
import { apiClient } from "@maat/api-base";
var roomsApi = {
  /** One pool room for the room page — no guest field; who is staying is booking's read. */
  getRoom: async (roomId, params) => {
    return apiClient.get(`/main/api/rooms/${roomId}`, { params });
  },
  /** Give a unit rooms (it becomes a room type), or add rooms to one. */
  createRooms: async (unitId, body) => {
    return apiClient.post(`/main/api/units/${unitId}/rooms`, body);
  },
  updateRoom: async (roomId, body) => {
    return apiClient.patch(`/main/api/rooms/${roomId}`, body);
  },
  deleteRoom: async (roomId) => {
    return apiClient.delete(`/main/api/rooms/${roomId}`);
  },
  /** Block nights on ONE room; a listing-addressed block fans out to every active room. */
  blockRoomDates: async (roomId, payload) => {
    return apiClient.post(`/main/api/rooms/${roomId}/calendar/block`, payload);
  },
  unblockRoomDates: async (roomId, payload) => {
    return apiClient.post(`/main/api/rooms/${roomId}/calendar/unblock`, payload);
  }
};

export {
  roomsApi
};
